module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger2-3f87b459779197ac64badcf63ff92af9.png";